import { Collapse } from 'bootstrap';

export class Call {
  constructor(data) {
    this.type = "Call";

    this.rootvm = data.rootvm;

    this.call_uuid = data.call_uuid;

    this.inserted = new Date(data.inserted);

    this.twilio_audio_link = data.twilio_audio_link;

    this.participant_one_name = data.participant_one_name;
    this.participant_one_number = data.participant_one_number;
    this.participant_two_name = data.participant_two_name;
    this.participant_two_number = data.participant_two_number;

    this.possible_bypass_attempt = ko.observable(data.possible_bypass_attempt);
    this.call_summary = data.call_summary;

    this.bypass_attempts = data.bypass_attempts ? new BypassAttempt(data.bypass_attempts) : null;
    this.event = data.event;
    this.event_uuid = data.event_uuid;
    this.gcs_blob_name = data.gcs_blob_name;
    this.initiator = data.initiator;
    this.initiator_uuid = data.initiator_uuid;
    this.sender = data.sender;
    this.transcription = data.transcription ? data.transcription.map(sentence => new TranscriptionSentence(sentence)) : [];
    this.current_state = data.current_state ? new CallState(data.current_state) : null;
    this.history = data.history ? data.history.map(historyItem => new CallState(historyItem)) : [];
  }

  jumpToSentence = (sentence_index) => {
    // Open the transcription section if it's not already open
    const collapseEl = document.getElementById('transcription-' + this.call_uuid);
    if (collapseEl && !collapseEl.classList.contains('show')) {
      const bsCollapse = new Collapse(collapseEl, { toggle: true });
      bsCollapse.show();
    }
    // Wait a moment to ensure the collapse animation has started
    setTimeout(() => {
      // Scroll to the specified sentence in the transcription
      const el = document.getElementById(this.call_uuid + '-sentence-' + sentence_index);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 500);

    return false; // Prevent default link behavior
  }
}

class CallState {
  constructor(data) {
    if (!data) data = {};

    this.actor = data.actor;
    this.call = data.call;
    this.call_state = data.call_state;
    this.call_uuid = data.call_uuid;
    this.effective = data.effective ? {
      lower: data.effective.lower ? new Date(data.effective.lower) : null,
      upper: data.effective.upper ? new Date(data.effective.upper) : null
    } : null;
    this.inserted = data.inserted ? new Date(data.inserted) : null;
    this.inserted_by = data.inserted_by;
    this.message = data.message;
    this.seen_by_user = data.seen_by_user ? new Date(data.seen_by_user) : null;
    this.sender = data.sender;
    this.updated = data.updated ? new Date(data.updated) : null;
  }
}

class TranscriptionSentence {
  constructor(data) {
    if (!data) data = {};

    this.bypass_attempt = data.bypass_attempt;
    this.bypass_type = data.bypass_type;
    this.confidence = data.confidence;
    this.end_time = data.end_time;
    this.media_channel = data.media_channel;
    this.sentence_index = data.sentence_index;
    this.sid = data.sid;
    this.start_time = data.start_time;
    this.transcript = data.transcript;
    this.words = data.words || [];

    // Computed properties for easier use in templates
    this.is_bypass_attempt = ko.pureComputed(() => this.bypass_attempt === true);
    this.formatted_start_time = ko.pureComputed(() => {
      if (this.start_time == null) return '';
      const minutes = Math.floor(this.start_time / 60);
      const seconds = Math.floor(this.start_time % 60);
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    });
    this.formatted_end_time = ko.pureComputed(() => {
      if (this.end_time == null) return '';
      const minutes = Math.floor(this.end_time / 60);
      const seconds = Math.floor(this.end_time % 60);
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    });
    this.confidence_percentage = ko.pureComputed(() => {
      if (this.confidence == null) return '';
      return Math.round(this.confidence * 100) + '%';
    });
  }
}

class BypassAttempt {
  constructor(data) {
    if (!data) data = {};

    this.sentence_idxs = data.sentence_idxs || [];
    this.summary = data.summary;

    // Computed property for checking if there are any bypass attempts
    this.has_attempts = ko.pureComputed(() => this.sentence_idxs.length > 0);
  }
}
